import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { syncUserLang } from "@/lib/i18n";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = anonymous

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setUser(null); return; }
    api
      .get("/auth/me")
      .then((r) => { setUser(r.data); syncUserLang(r.data); })
      .catch(() => {
        localStorage.removeItem("token");
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));
    setUser(data.user);
    syncUserLang(data.user);
    return data.user;
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    localStorage.setItem("user", JSON.stringify(data));
    return data;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, refreshUser }}>{children}</AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}

export const STAFF_ROLES = ["admin", "direzione", "segreteria", "docente", "raccolta_fondi"];
export function isStaff(user) { return user && STAFF_ROLES.includes(user.role); }
export function isStudent(user) { return user?.role === "studente"; }
export function isTeacher(user) { return user?.role === "docente"; }
export function isAdminOrSegreteria(user) { return user && ["admin", "direzione", "segreteria"].includes(user.role); }
export function isFundraising(user) { return user?.role === "raccolta_fondi"; }
export function isEconomato(user) { return user?.role === "economato"; }
export function canManageFundraising(user) { return user && ["admin", "direzione", "segreteria", "raccolta_fondi"].includes(user.role); }
